export const LIMIT_ARROW = 3;
export const MIN_WIDTH = 200;
